module.exports = __webpack_public_path__ + "static/media/compare-your-footprint.f1bbe4d5.png";